import { useReducer, useState } from 'react';
import { Permissions, PermissionAction, PermissionActionTypes } from '../types';

export const usePermissionsList = () => {
  const [hasChanges, setHasChanges] = useState(false);

  const permissionsReducer = (state: Permissions, action: PermissionAction) => {
    const { type, checkedState, resetState } = action;
    switch (type) {
      case PermissionActionTypes.SNAPSHOT:
        if (!checkedState) return state;
        if (checkedState.checked) {
          setHasChanges(true);
          return {
            ...state,
            permittedSnapshotIds: [
              ...state.permittedSnapshotIds,
              Number(checkedState.id),
            ],
          };
        } else {
          setHasChanges(true);
          return {
            ...state,
            permittedSnapshotIds: state.permittedSnapshotIds.filter(
              (id) => id !== Number(checkedState.id)
            ),
          };
        }
      case PermissionActionTypes.ANALYZER:
        if (!checkedState) return state;
        if (checkedState.checked) {
          setHasChanges(true);
          return {
            ...state,
            permittedAnalyzerIds: [
              ...state.permittedAnalyzerIds,
              Number(checkedState.id),
            ],
          };
        } else {
          setHasChanges(true);
          return {
            ...state,
            permittedAnalyzerIds: state.permittedAnalyzerIds.filter(
              (id) => id !== Number(checkedState.id)
            ),
          };
        }
      case PermissionActionTypes.RESET:
        setHasChanges(false);
        if (resetState) return resetState;
        else return state;
      default:
        return state;
    }
  };

  const [userPermissions, dispatchUserPermissions] = useReducer(
    permissionsReducer,
    { permittedSnapshotIds: [], permittedAnalyzerIds: [] }
  );

  return { userPermissions, dispatchUserPermissions, hasChanges };
};
